import { makeAutoObservable } from 'mobx';
import { CreativeModel } from './creative.model';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { Status } from '../enums/status';

export interface ICampaignCreative {
	creative?: CreativeModel;
	creative_group?: string;
	id?: id;
	status?: Status;
	weight?: number;
}

export class CampaignCreativeModel implements ICampaignCreative {
	creative?: CreativeModel;
	creative_group?: string;
	id?: id;
	status?: Status;
	weight?: number;

	constructor(campaignCreative?: ICampaignCreative) {
		this.creative = new CreativeModel(campaignCreative?.creative);
		this.creative_group = campaignCreative?.creative_group;
		this.id = campaignCreative?.id;
		this.status = campaignCreative?.status;
		this.weight = campaignCreative?.weight;

		makeAutoObservable(this);
	}

	public getId() {
		return this.id;
	}

	public setId(id: id) {
		this.id = id;
	}

	public getStatus(): Status | undefined {
		return this.status;
	}

	public setStatus(status: Status): void {
		this.status = status;
	}

	public getCreative(): CreativeModel | undefined {
		return this.creative;
	}
	public setCreative(creative: CreativeModel): void {
		this.creative = creative;
	}
}
